import { Box, HStack, Image, Stack, Text } from '@chakra-ui/react';

import IdNotVerifiedIllustration from '../../../../assets/icons/ID Not Verified.svg';
import SecurityCheckBlueIcon from '../../../../assets/icons/security-check-blue.svg';
import {
  CustomModal,
  PrimaryButton,
  SecondaryButton,
} from '../../../../components/custom';

interface TwoFactorSetupPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSetupNow: () => void;
  onSetupLater: () => void;
}

export default function TwoFactorSetupPromptModal({
  isOpen,
  onClose,
  onSetupNow,
  onSetupLater,
}: TwoFactorSetupPromptModalProps) {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      modalMaxWidth="500px"
      allowBottomPadding={false}
    >
      <Stack spacing={6} align="center" textAlign="center" pt={2}>
        <Image
          src={IdNotVerifiedIllustration}
          alt=""
          boxSize="140px"
          flexShrink={0}
        />

        <Stack spacing={2}>
          <Text fontSize="1.75rem" fontWeight={500} lineHeight="129%">
            Setup Two-Factor Authenticator
          </Text>
          <Text color="gray.300" fontSize="1rem" lineHeight="150%">
            Adds an extra layer of security to your 9jaPay Business account to
            protect you from unauthorized transactions.
          </Text>
        </Stack>

        <Box bg="#E8F4FA" borderRadius="12px" p={4} w="full" textAlign="left">
          <HStack spacing="6px" mb={2}>
            <Image src={SecurityCheckBlueIcon} alt="" boxSize="16px" />
            <Text fontSize=".75rem" fontWeight={500} letterSpacing="0.2px">
              Why is this required?
            </Text>
          </HStack>
          <Text color="gray.300" fontSize=".75rem" lineHeight="130%">
            2FA adds an extra layer of protection to your business account.
            You&apos;ll verify your identity each time you log in using one of
            the available methods.
          </Text>
        </Box>

        <Stack spacing={3} w="full" pt={2}>
          <PrimaryButton w="full" onClick={onSetupNow}>
            Setup 2FA Now
          </PrimaryButton>
          <SecondaryButton w="full" onClick={onSetupLater}>
            Setup Later
          </SecondaryButton>
        </Stack>
      </Stack>
    </CustomModal>
  );
}
